import React, {useState} from "react"
import PropTypes from "prop-types"
import {
    Container,
    Card,
    CardBody,
    Nav,
    NavItem,
    NavLink,
} from "reactstrap"
import classnames from "classnames"
import Affectation from "./Affectation";

const AffectationSem = props => {
    const [section, setSection] = useState("")
    const [semestre, setSemestre] = useState([
        {value: 1, label: "Semestre 1", section: 0},
        {value: 2, label: "Semestre 2", section: 1},
    ])


    const renderBlock = section => {
        for (let i = 0; i < semestre.length; i++) {
            if (section === i) {
                return <Affectation semestre={semestre[i]}/>
            }
        }
    }

    return (
        <React.Fragment>

            <Container fluid>
                <Card>
                    <CardBody>
                        <Nav className="icon-tab nav-justified">
                            {semestre.map((element, index) => (
                                <NavItem key={index}>
                                    <NavLink
                                        style={{cursor: "pointer"}}
                                        className={classnames({
                                            active: section === element.section,
                                        })}
                                        onClick={() => {
                                            setSection(element.section)
                                        }}
                                    >
                                        <span className="d-none d-sm-block">{element.label}</span>
                                    </NavLink>
                                </NavItem>
                            ))}
                        </Nav>
                        {renderBlock(section)}
                    </CardBody>
                </Card>
            </Container>

        </React.Fragment>
    )
}

export default AffectationSem
AffectationSem.propTypes = {
    history: PropTypes.object,
}
